import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ab5816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loby-root" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loby-logo" }, null, -1))
const _hoisted_4 = { class: "info user-name" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "info user-coin" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = {
  key: 0,
  class: "tab-menu"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1))
const _hoisted_10 = { class: "value-btns" }
const _hoisted_11 = { class: "value-btns" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "m-header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-logo" }, null, -1))
const _hoisted_15 = { class: "m-info m-user-name" }
const _hoisted_16 = { class: "m-value" }
const _hoisted_17 = { class: "m-info m-user-coin" }
const _hoisted_18 = { class: "m-value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-fill" }, null, -1))
const _hoisted_20 = { class: "m-tab-menu" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-fill" }, null, -1))
const _hoisted_22 = { class: "m-limit" }
const _hoisted_23 = { class: "content-wrap" }
const _hoisted_24 = {
  key: 0,
  class: "content"
}
const _hoisted_25 = {
  key: 0,
  class: "multi-select-footer-info"
}
const _hoisted_26 = ["data-info"]
const _hoisted_27 = {
  key: 0,
  class: "content multi"
}
const _hoisted_28 = { class: "multi-table-betting" }
const _hoisted_29 = { class: "multi-item-group" }
const _hoisted_30 = { class: "chips-group-control" }
const _hoisted_31 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user_l = _resolveComponent("i-user-l")!
  const _component_i_balance = _resolveComponent("i-balance")!
  const _component_ctrl_dropdown = _resolveComponent("ctrl-dropdown")!
  const _component_i_balance_g = _resolveComponent("i-balance-g")!
  const _component_i_one_bar = _resolveComponent("i-one-bar")!
  const _component_i_two_bar = _resolveComponent("i-two-bar")!
  const _component_icon_full_screen = _resolveComponent("icon-full-screen")!
  const _component_i_arrow_h = _resolveComponent("i-arrow-h")!
  const _component_icon_user1 = _resolveComponent("icon-user1")!
  const _component_icon_dolar = _resolveComponent("icon-dolar")!
  const _component_list_item = _resolveComponent("list-item")!
  const _component_multi_table_item = _resolveComponent("multi-table-item")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!
  const _component_marquee_text = _resolveComponent("marquee-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.coin), 1)
      ]),
      (!_ctx.isFreeUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 0 }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDeskFilter(0)))
            }, _toDisplayString(_ctx.t('loby.all')), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 1 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDeskFilter(1)))
            }, _toDisplayString(_ctx.t('loby.baccarat')), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 2 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeDeskFilter(2)))
            }, _toDisplayString(_ctx.t('loby.dragontiger')), 3),
            (_ctx.commandType === 2 && !_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 3 }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeDeskFilter(3)))
                }, _toDisplayString(_ctx.t('loby.multiple')), 3))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_9,
      (!_ctx.isFreeUser && _ctx.tabId !== 3)
        ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
            key: 1,
            class: "drop-down-game-type",
            listData: _ctx.gameOptionArray,
            labelName: 'typeName',
            modelValue: _ctx.gameOption,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.gameOption) = $event))
          }, null, 8, ["listData", "modelValue"]))
        : _createCommentVNode("", true),
      (!_ctx.isFreeUser && _ctx.tabId !== 3)
        ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
            key: 2,
            class: "drop-down-game-limit",
            listData: _ctx.limitOptionArray,
            modelValue: _ctx.limitOption,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.limitOption) = $event))
          }, null, 8, ["listData", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (
                    _ctx.tabId === 3 &&
                    _ctx.isMultitbableView &&
                    _ctx.getMultitableIds() !== ''
                )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-ss",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
              }, [
                _createVNode(_component_i_balance_g, { class: "icon-btns" }),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('loby.tip')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (
                _ctx.tabId === 3 &&
                _ctx.isMultitbableView &&
                _ctx.getMultitableIds() !== ''
            )
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "btn-ss btn-switch-playmode",
            onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchPlayMode && _ctx.switchPlayMode(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('dialogs.gameplay.switchplaymode')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_i_one_bar, {
        class: _normalizeClass(["icon one-bar", { active: _ctx.listDisplayType === 0 }]),
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.onChangeListDisplayType(0)), ["prevent"]))
      }, null, 8, ["class"]),
      _createVNode(_component_i_two_bar, {
        class: _normalizeClass(["icon two-bar", { active: _ctx.listDisplayType === 1 }]),
        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.onChangeListDisplayType(1)), ["prevent"]))
      }, null, 8, ["class"]),
      (_ctx.fullScreenAvailable)
        ? (_openBlock(), _createBlock(_component_icon_full_screen, {
            key: 4,
            class: "icon full",
            "is-on": !_ctx.isfullScreen,
            onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
          }, null, 8, ["is-on", "onClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "drop-down-setting",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('loby.menu')), 1),
        _createVNode(_component_i_arrow_h, { class: "icon-arrow" })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", null, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_icon_user1, { class: "m-icon m-user-l" }),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.user), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_icon_dolar, { class: "m-icon m-balance" }),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.coin), 1)
        ]),
        _hoisted_19,
        _createElementVNode("div", {
          class: "m-btn-setting",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.t('loby.menu')), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: _normalizeClass(["m-tab-item", { active: _ctx.tabId === 0 }]),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeDeskFilter(0)))
          }, _toDisplayString(_ctx.t('loby.all')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["m-tab-item", { active: _ctx.tabId === 1 }]),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeDeskFilter(1)))
          }, _toDisplayString(_ctx.t('loby.baccarat')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["m-tab-item", { active: _ctx.tabId === 2 }]),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeDeskFilter(2)))
          }, _toDisplayString(_ctx.t('loby.dragontiger')), 3)
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", null, _toDisplayString(_ctx.t('multibetting.redlimit')), 1),
          (!_ctx.isFreeUser)
            ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
                key: 0,
                class: "drop-down-game-limit",
                listData: _ctx.limitOptionArray,
                modelValue: _ctx.limitOption,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.limitOption) = $event))
              }, null, 8, ["listData", "modelValue"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_Transition, { name: "slide-down" }, {
        default: _withCtx(() => [
          (!_ctx.isMultitbableView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(), _createElementBlock("div", {
                  class: "content-list",
                  key: _ctx.listKey
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDesk, (desk) => {
                    return (_openBlock(), _createBlock(_component_list_item, {
                      class: _normalizeClass(["content-list-item", {
                            'grid-3': _ctx.listDisplayType === 1,
                            'selected':
                                _ctx.tabId === 3 &&
                                _ctx.multiTableSelected.indexOf(desk.id) !== -1
                        }]),
                      key: desk.id,
                      mData: desk,
                      activeDesk: _ctx.currentDeskNo,
                      displayType: _ctx.listDisplayType,
                      onClick: ($event: any) => (_ctx.handleSelectDesk(desk.id, desk))
                    }, null, 8, ["class", "mData", "activeDesk", "displayType", "onClick"]))
                  }), 128))
                ])),
                (!_ctx.isMultitbableView && _ctx.tabId === 3 && !_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", {
                        class: "start-multi-betting",
                        "data-info": _ctx.multiTableSelectTip(),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.gotoMultitableView()))
                      }, _toDisplayString(_ctx.t('loby.startmultibetting')), 9, _hoisted_26)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "slide-up" }, {
        default: _withCtx(() => [
          (_ctx.isMultitbableView && !_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk1,
                      position: 0,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk2,
                      position: 1,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk3,
                      position: 2,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk4,
                      position: 3,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_ctrl_chips, { class: "chips-group" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_31, [
      (_openBlock(), _createBlock(_component_marquee_text, {
        class: "m-notice",
        speed: 30,
        key: _ctx.noticeKey
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.lobyNotice), 1)
        ]),
        _: 1
      }))
    ])
  ]))
}